import { render, staticRenderFns } from "./FeaturedPostThumbMod.vue?vue&type=template&id=2942bb12"
import script from "./FeaturedPostThumbMod.vue?vue&type=script&lang=js"
export * from "./FeaturedPostThumbMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports